import { legacy_createStore, combineReducers, applyMiddleware } from "redux";
import thunk from 'redux-thunk'
import { composeWithDevTools } from "redux-devtools-extension";
import { getAdviceLogBook,getManagerTab,getAdminTaskTab,getPagination,getCompanyMasterTab, getSystematicPlanTab,getSentForReviewTab, getUserProfileId, getAdminInvoiceTab,getslabTypeTab, getAdminMyTaskTaskTab, userLoginReducer, getAdminAssignTaskTab, getShareTab,getAdminAgreementTab, getData } from "../reducers/AuthReducer";

const reducers = combineReducers({
    userLogin: userLoginReducer,
    systematicPlanTab: getSystematicPlanTab,
    adminIncoiceTab: getAdminInvoiceTab,
    slabTypeTab: getslabTypeTab,
    adminAssignTaskTab: getAdminAssignTaskTab,
    adminMyTaskTab: getAdminMyTaskTaskTab,
    userProfileId: getUserProfileId,
    adviceLogBook: getAdviceLogBook,
    shareTab: getShareTab,
    sentForReview: getSentForReviewTab,
    managerTab: getManagerTab,
    companyMasterTab: getCompanyMasterTab,
    pagination:getPagination,
    adminTaskTab:getAdminTaskTab,
    adminAgreementTab:getAdminAgreementTab,
    getData
})

const initialState = {}

const middleware = [thunk]

const store = legacy_createStore(
    reducers,
    initialState,
    composeWithDevTools(applyMiddleware(...middleware))
)

export default store;

export type RootState = ReturnType<typeof store.getState>